import { useState } from 'react';
import { Divider, Typography } from 'antd';
import { CargoList } from '../cargo-list';
import styles from './order-cargoes-details.module.scss';
import type { IOrderCargoesDetailsProps } from './types';

const { Text } = Typography;

export const OrderCargoesDetails: React.FC<IOrderCargoesDetailsProps> = ({ orderId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div>
      <Divider className={styles.divider} dashed />
      {isOpen && <CargoList orderId={orderId} />}
      {isOpen && <Divider className={styles.divider} dashed />}
      <Text type='secondary' className={styles.details} onClick={handleOpen}>
        {isOpen ? 'Hide details' : 'Show details'}
      </Text>
    </div>
  );
};
